import { Vue, Component, Prop } from 'vue-property-decorator'
import SfImageElement from '~/components/element/SfImageElement'
import Image from '~/types/api/Image'

@Component
export default class StaticPageImageFooter extends Vue {
  @Prop({ type: Array, required: true })
  images!: Image[]

  @Prop({ type: String, default: 'Изображения' })
  blockName!: string

  render() {
    if (this.images.length === 0) return null;

    return (
      <div>
        <br />
        <h1>{this.blockName}</h1>
        <div class="image-gallery">
          {this.images.map((image) => (
            <div key={image.id} class="image-item">
              <SfImageElement
                {...{
                  props: {
                    img: image
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }
}